<div class="flex items-center">
    <ui-icon title="Talk with agent" name="bot" size="size-6"
    class="stroke-[#5D5D5D] cursor-not-allowed ml-2"
    ></ui-icon>

    <span
    class="text-xs px-2.5 py-1 mx-1  text-[#475467] text-center opacity-80 cursor-not-allowed"
    >
    {{ title() }}
    </span>

    <span class="px-3 py-1 text-xs text-black font-medium border-2 border-[#0F49A0] rounded-full bg-gradient-to-r from-white to-pink-100 pointer-events-none">
    Coming soon
    </span>
</div>


   
